export default function({ error: nuxtError }, inject) {
    inject('handle404', error => {
        if (error?.response?.status === 404) {
            nuxtError({ statusCode: error.response.status })
        }
    })
}